// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"652":"cc213abb","769":"536a95e7"}[chunkId] + ".chunk.js";
};